import { splitMissingTokens } from 'features/knowledgeDocumentViewer/artifacts/missingMarkers'
import type { Element, Root, RootContent, Text } from 'hast'

export const MISSING_MARKER_PROPERTY = 'dataMissing'

function markerElement(index: number): Element {
  return {
    type: 'element',
    tagName: 'span',
    properties: { [MISSING_MARKER_PROPERTY]: String(index) },
    children: [{ type: 'text', value: '***' }],
  }
}

function splitText(text: Text): (Text | Element)[] {
  const parts = splitMissingTokens(text.value)
  if (parts.length === 1 && parts[0]?.type === 'text') return [text]
  return parts.map((part) =>
    part.type === 'text'
      ? { type: 'text', value: part.text }
      : markerElement(part.index)
  )
}

function replaceMarkerTokens<C extends RootContent>(
  child: C
): (C | Text | Element)[] {
  if (child.type === 'text') return splitText(child)
  if (child.type === 'element') {
    child.children = child.children.flatMap(replaceMarkerTokens)
  }
  return [child]
}

/**
 * Rehype plugin that turns every leftover `***` token, wherever markdown put
 * it (code spans, block quotes, deep headings, strikethrough, any container),
 * into a `span` carrying its marker index, so one component renders them all.
 */
export function rehypeMissingMarkers() {
  return (tree: Root) => {
    tree.children = tree.children.flatMap(replaceMarkerTokens)
  }
}
